





























import { Component, Vue } from "vue-property-decorator";

import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import ServiceMenuStatusIconWithText from "@/components/service-status/ServiceMenuStatusIconWithText.vue";
import { ServiceMenuStatus } from "@/consts/const";

@Component({
  components: { ServiceMenuStatusIconWithText, ServiceMenuStatusIcon },
})
export default class ServiceMenuStatusExplanation extends Vue {
  private ServiceMenuStatus = ServiceMenuStatus;
}
